import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
 
 
  box-sizing: border-box;
  width:100%;
  background-color:#1F1F1F;
  padding:5% 0% 10% 0%;

`;

const SectionWrapper = styled.section`
 
 
  box-sizing: border-box;
  width:60%;
  margin: 0 auto;
  background-color:#1F1F1F;

  @media (max-width: 500px) {
    width:90%;
    padding: 0%;
  }
`;


const Title = styled.h2`
  // margin-left:35%;
  margin:0 auto;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding:0% 0% 2.5% 0%;
  
  


  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    width:70%;
    font-size: 32px;
    line-height: 40px;
    padding:10% 0% 5% 0%;
    margin: 0 auto;

  }


`;

const GoalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  position: relative; 


  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;


  }
`;

const GoalCard = styled.a`
  position: relative;
  flex: 1;
  max-width: calc(33% - 2px);
  background-color: #333333;
  border-radius: 30px;
  text-align:center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #333333;  
  overflow: hidden;
  text-decoration: none;
  



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: calc(100% - 0px);
    max-width: 100%;
    margin-bottom: 8px; 
 
  }

  &:hover {
    border: 1px solid #FFF56A;


  }




`;



const GoalImage = styled.img`
  width: 90%;
  height: auto;
  object-fit: cover;
  margin-bottom: 0px;
  padding:0% 5% 10% 5%;
  

  @media (max-width: 500px) {
   
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
    padding:0% 5% 5% 5%;
  }
`;


const GoalText = styled.div`
  display: flex;
  flex-direction: row; 
  align-items: center;
  text-align: center;
  font-weight: 400;
  font-size: 28px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: flex-start;
  padding: 10% 0% 2.5% 0%;
  gap: 8px;
  margin-bottom: 16px;
  position: relative; 



  img{
    height:28px;
    padding: 1% 0% 0% 0% ;
  }

  ${GoalCard}:hover & {
    color: #FFFF56;
  }

  @media (max-width: 500px) {
    font-size: 18px;
    padding:5% 5% 0% 5%;
    gap: 0px;
    line-height: 24px;

    img{
      height:22px;
      padding: 1% 0% 0% 0% ;
    }

   
  
  }

`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 將元素靠左和靠右對齊 */
  width: 100%; /* 確保 ButtonContainer 佔滿父容器的寬度 */
  margin-right:0px;
  margin-bottom:1%;

  @media (max-width: 500px) {
    margin-bottom:5%;

    margin-top:0%;

  }
`;


const DIDSection5 = () => (
  <Section>
  <SectionWrapper>
    <Title>體驗分散式身分<span>.</span></Title>
    <ButtonContainer>
      <Button href="https://drive.google.com/file/d/1bRGBkevKEwcrUbLELyDY58i2eusXul5Y/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
    </ButtonContainer>
    <GoalContainer>
      {/* Goal 1 */}
      
      <GoalCard href="https://rxca-application.plurality.moda.gov.tw/" target="_blank">
      
        
        <GoalText>體驗超韌組織型態<img src="/images/Arrow45.png" /></GoalText>
        <GoalImage src="/images/DIDSec5_1.png" alt="Goal 1" />
       
      </GoalCard>
      

      {/* Goal 2 */}
      
      <GoalCard href="https://taiwandid.plurality.moda.gov.tw/" target="_blank">
        
        <GoalText>建立 Taiwan DID 身分<img src="/images/Arrow45.png" /></GoalText>
        <GoalImage src="/images/DIDSec5_2.png" alt="Goal 2" />

      </GoalCard>
      

      {/* Goal 3 */}
     
      <GoalCard href="https://rivercare.plurality.moda.gov.tw" target="_blank">
        
        <GoalText>與曾文溪對話<img src="/images/Arrow45.png" /></GoalText>
        <GoalImage src="/images/DIDSec5_3.png" alt="Goal 3" />

      </GoalCard>
      

  
    </GoalContainer>
  </SectionWrapper>
  </Section>
);

export default DIDSection5;
